import { render } from "./connect-wallet-card-bg.svg?vue&type=template&id=3ec0d257"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__